export const AUTO_MAX_HEIGHT_TABLE = 400

export const SCORE_OPTION = {
  CREDIT_SCORE: 'CREDIT_SCORE',
  PERFORMANCE_SCORE: 'PERFORMANCE_SCORE',
}

export const SCORE_BY_VALUE = {
  CREDIT_SCORE: 'portfolioScore.creditRisk',
  PERFORMANCE_SCORE: 'portfolioScore.performance',
}

export const TYPE_SELECT_SCORE = [
  {
    label: 'portfolioScore.creditRisk',
    value: SCORE_OPTION.CREDIT_SCORE,
    isI18n: true,
  },
  {
    label: 'portfolioScore.performance',
    value: SCORE_OPTION.PERFORMANCE_SCORE,
    isI18n: true,
  },
]

export const HIGH_LIGHT_TITLE = {
  totalCompanies: 'TOTAL_COMPANIES',
  mainProvince: 'MAIN_PROVINCE',
  mainSector: 'MAIN_SECTOR',
  mostPopularBusinessSize: 'MOST_BUSINESS_SIZE',
  mostPopularYearsOfOperation: 'YEARS_OF_OPERATION',
}

export const COLORS = ['#006AA6', '#FFCD60', '#D96383', '#74B49A', '#BCBCBC']
